import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Name")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Slug")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Description translation")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Is form enabled")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Subscription type")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Process type")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Access allowed after")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Packages")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Open End date")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Access duration")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_free_forms_editable_field_name = _resolveComponent("free-forms-editable-field-name")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_free_forms_editable_field_slug = _resolveComponent("free-forms-editable-field-slug")!
  const _component_free_forms_editable_field_description_translation = _resolveComponent("free-forms-editable-field-description-translation")!
  const _component_free_forms_editable_field_is_form_enabled = _resolveComponent("free-forms-editable-field-is-form-enabled")!
  const _component_free_forms_editable_field_access_allow_after = _resolveComponent("free-forms-editable-field-access-allow-after")!
  const _component_free_forms_open_dialog_field_packages = _resolveComponent("free-forms-open-dialog-field-packages")!
  const _component_free_forms_editable_field_end_date = _resolveComponent("free-forms-editable-field-end-date")!
  const _component_free_forms_editable_field_access_duration = _resolveComponent("free-forms-editable-field-access-duration")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_list, {
      class: "q-mb-lg",
      padding: "",
      bordered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_free_forms_editable_field_name, {
                  modelValue: _ctx.freeFormModel.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.freeFormModel.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_free_forms_editable_field_slug, {
                  modelValue: _ctx.freeFormModel.slug,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.freeFormModel.slug) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium self-start q-mt-sm" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_free_forms_editable_field_description_translation, {
                  modelValue: _ctx.freeFormModel.descriptionTranslation,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.freeFormModel.descriptionTranslation) = $event)),
                  isFormEnabled: _ctx.freeFormModel.isEnabled
                }, null, 8, ["modelValue", "isFormEnabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_free_forms_editable_field_is_form_enabled, {
                  modelValue: _ctx.freeFormModel.isEnabled,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.freeFormModel.isEnabled) = $event)),
                  areTranslationsReady: _ctx.freeFormModel.areTranslationsReady
                }, null, 8, ["modelValue", "areTranslationsReady"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.freeFormModel.subscriptionType), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.freeFormModel.processType), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_free_forms_editable_field_access_allow_after, {
                  modelValue: _ctx.freeFormModel.accessAfterDays,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.freeFormModel.accessAfterDays) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium self-start" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_free_forms_open_dialog_field_packages, {
                  freeFormPackages: _ctx.freeFormModel.packages
                }, null, 8, ["freeFormPackages"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.shouldShowEndDate)
          ? (_openBlock(), _createBlock(_component_q_item, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_free_forms_editable_field_end_date, {
                      modelValue: _ctx.freeFormModel.endDate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.freeFormModel.endDate) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.shouldShowAccessDuration)
          ? (_openBlock(), _createBlock(_component_q_item, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_free_forms_editable_field_access_duration, {
                      modelValue: _ctx.freeFormModel.accessDuration,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.freeFormModel.accessDuration) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_q_btn, {
      to: { name: _ctx.FreeFormsRouteNames.LIST, query: { page: _ctx.route.query.page }, params: { restoreFilters: 1 } },
      label: "Back to listing",
      color: "primary",
      "no-caps": "",
      outline: ""
    }, null, 8, ["to"])
  ], 64))
}